module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Menu_Main":{"pattern.store.position":[{"value":60,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Menu_Main","_fox_":1}],"pattern.store.title":[{"value":"Store","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Menu_Main","_fox_":1}],"pattern.store.url":[{"value":"\u002Fstore","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Menu_Main","_fox_":1}],"pattern.store.checkers.store.callback":[{"value":function () {				
return !fox.isEmpty(fox.getEnv('store.enabled'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.Menu_Main","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/store.js
// module id = 696
// module chunks = 4